import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {loadMeAction} from '../../reducers/user';
import {loadCountsForSidenavAction} from '../../reducers/analytics';

import {useFormData} from '../../hook';

import {initDatas} from './common';

import UIKit from '../../Components/UIKit';
import OrderCancelTableStyle from '../../Components/Widget/Order/CancelTableStyle';
import SearchHead from '../../Components/Widget/SearchHead';
import SearchModal from '../../Components/Widget/SearchModal';
import SearchForm from '../../Components/Widget/SearchForm';

const DetailList = ({history, match}) => {
  const dispatch = useDispatch();
  const {loadMeLoading, me, loadMeDone, loadMeError} = useSelector(state => state.user);

  const searchForm = useFormData({
    dateSelect: 'all',
    dateRadio: '',
    startDate: '',
    endDate: '',
    searchType: 'all',
    searchValue: '',
    status: 'all',
  });

  useEffect(() => {
    dispatch(loadMeAction());
    dispatch(loadCountsForSidenavAction());
  }, []);

  return loadMeLoading
    ? null
    : loadMeDone && (
        <div>
          <div>
            <SearchHead modalId={'reviewSearchModal'} />
            <SearchModal modalId={'reviewSearchModal'} searchForm={searchForm}>
              <SearchForm searchForm={searchForm} useSearchComponents={initDatas.useSearchComponents} />
            </SearchModal>
          </div>
          <div className="uk-margin-medium-top">
            <OrderCancelTableStyle payType={1} payMethod={'VBANK'} />
          </div>
        </div>
      );
};

export default DetailList;
